<div id="container">
  <mat-card appearance="outlined">
    @switch (status | async) {
      @case ('ready') {
        <!-- INFO ICON -->
        @if (description) {
          <div id="info-icon" [matTooltip]="description" matTooltipPosition="left">
            <mat-icon>info</mat-icon>
          </div>
        }
        <!-- BODY -->
        <div id="main" fxLayout="column" fxLayoutAlign="space-around stretch">
          <div id="value">{{ formatNumber(value, valueType) }}
            @if (displayTrend && value && subValue) {
              <span class="trend">{{ getTrendPercentage(value, subValue) }} @if (value !== subValue) {
                <mat-icon [class.up]="value > subValue" [class.down]="value < subValue">{{ value > subValue ? 'trending_up' : 'trending_down' }}</mat-icon>
              }</span>
            }
          </div>
          <div id="title">{{ cardTitle }}</div>
          @if (subValue !== undefined) {
            <div id="subValue">
              {{ formatNumber(subValue, subValueType) }} @if (subValueName !== undefined) {
              <span>{{ subValueName }}</span>
            }
          </div>
        }
      </div>
      <!-- FOOTER -->
      @if (valueType === 'percent') {
        <div class="footer-outline percent-footer {{ color }}"></div>
        <div class="footer-fill percent-footer {{ color }}" [ngStyle]="{ 'width.%': (value <= 1 ? value * 100 : 100) }"></div>
      } @else {
        <div class="footer-fill normal-footer {{ color }}"></div>
      }
    }
    @case ('loading') {
      <div id="mainLoading" fxLayout="column" fxLayoutAlign="space-around stretch">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 250 90" preserveAspectRatio="xMidYMid slice">
          <rect x="0" y="0" width="187.5" height="35" rx="3" ry="3" fill="#e5ebee"></rect>
          <rect x="0" y="48" width="225" height="28" rx="3" ry="3" fill="#e5ebee"></rect>
        </svg>
      </div>
    }
    <!-- ERROR PLACEHOLDER -->
    @case ('error') {
      <div id="errorContainer" fxLayout="row" fxLayoutAlign="center center" fxFill>
        <mat-icon>error</mat-icon>
      </div>
    }
  }
</mat-card>
</div>
